module.exports = __webpack_public_path__ + "img/09.50f882af.jpg";